export { boxAndInventorySelector } from '../../../../redux/product-listing/product-listing.selectors';
export const shopCustomColorsSelector = () => ({
  secondaryColor: '#FF0000FF',
  primaryColor: '#0000FFFF'
});